export var PopupMessageTypeClasses = {
    dialog: "rj-popup-message--dialog",
    notification: "rj-popup-message--notification"
};
export var PopupMessageButtonClasses = {
    default: "rj-popup-message__btn--default",
    negative: "rj-popup-message__btn--negative",
    positive: "rj-popup-message__btn--positive" //green
};
export var PopupMessageDefaultConfig = {
    header: "",
    body: "",
    closeBtn: true,
    type: PopupMessageTypeClasses.notification,
    className: "",
    actions: {}
};
//# sourceMappingURL=PopupMessageConstants.js.map